import styled from 'styled-components';

export const HeadingSeoSection = styled.section`
  @media (max-width: 720px) {
    padding: ${(props) =>
      props.reviewStyle || props.author || !props.length || props.length === 0
        ? '0'
        : '0px 4px 20px 12px'};
  }

  .readMore {
    color: #63b0a8;
    font-size: 12px;
    font-weight: 500;
    cursor: default;
    transition: all 0.15s ease;
    display: ${(props) =>
      props.length > 200 || props.mobileCharLimit < props.length
        ? 'block'
        : 'none'};

    &:hover {
      text-decoration: underline;

      @media (max-width: 720px) {
        text-decoration: none;
      }
    }

    @media (min-width: 720px) {
      cursor: pointer;
      display: ${(props) =>
        props.length < props.desktopLimit ? 'none' : 'block'};
    }
  }
`;
export const MainPageTitle = styled.h1`
  color: hsl(0deg, 0%, 0%, 80%);
  font-size: clamp(20px, 2vw, 24px);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 5px;
  text-align: center;
  padding-bottom: clamp(10px, 2vw, 16px);
  @media (max-width: 720px) {
    letter-spacing: 3px;
    line-height: 32px;
  }
`;

export const SeoContent = styled.p`
  font-size: ${(props) => (props.showNewReviewView ? '14px' : props.fontSize)};
  font-weight: 500;
  color: ${(props) =>
    props.showNewReviewView ? 'rgba(0, 0, 0, 0.75)' : 'hsl(0deg, 0%, 0%, 68%)'};
  line-height: ${(props) => (props.author ? 'unset' : '19px')};
  display: -webkit-box;
  -webkit-line-clamp: ${(props) =>
    props.mobileCharLimit < props.length
      ? '3'
      : props.length < 200
        ? 'inherit'
        : props.maternity || props.reviewStyle
          ? '3'
          : '4'};
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: all 0.2s ease;
  max-width: ${(props) => (props.reviewStyle ? '90%' : '100%')};

  &.fullContent {
    -webkit-line-clamp: inherit;
    transition: all 0.2s ease;
    height: auto;
  }

  @media (min-width: 720px) {
    -webkit-line-clamp: ${(props) =>
      props.length < props.desktopLimit ? 'inherit' : props.desktopClamp};
  }

  margin-top: ${(props) => (props.showNewReviewView ? '8px' : '0')};
`;
export const HeadTitle = styled.div`
  max-width: 100%;
  margin: auto;
  padding: ${(props) => (props.filter ? '0px 2.5%' : '0px')};
  @media (max-width: 720px) {
    max-width: 100%;
  }
`;

export const Title = styled.h1.attrs((props) => ({
  as: props.showNewReviewView ? 'h2' : 'h1',
}))`
  font-size: ${(props) =>
    props.showNewReviewView ? '16px' : 'clamp(17px, 2vw, 22px)'};
  letter-spacing: ${(props) => (props.showNewReviewView ? 'normal' : '0.3px')};
  color: ${(props) =>
    props.showNewReviewView
      ? 'rgba(0, 0, 0, 0.8);'
      : props.maternity
        ? '#63b0a8'
        : 'hsl(0deg, 0%, 0%, 87%)'};
  padding: ${(props) =>
    props.showNewReviewView
      ? '6px 0 6px'
      : props.maternity
        ? '0px 2px 6px'
        : '18px 0 6px'};
  text-align: ${(props) =>
    props.showNewReviewView
      ? 'left'
      : props.maternity
        ? 'center'
        : '18px 0 6px'};
  margin-top: ${(props) => (props.maternity ? '8px' : '0')};

  @media (min-width: 720px) {
    text-align: ${(props) => (props.showNewReviewView ? 'left' : 'center')};
    letter-spacing: ${(props) => (props.showNewReviewView ? '' : '3px')};
    text-transform: ${(props) => (props.showNewReviewView ? '' : 'uppercase')};
    padding: 18px 0 16px;
  }
`;
